// TODO(WORK-5920): remove this bridge once antd v5 lands and the pickers use dayjs.

/* eslint-disable no-restricted-imports -- this is the single canonical moment island; the antd v4 picker wrappers under @common/components are the only consumers of these helpers. */
import moment, { type Moment } from 'moment';

import {
  datetime,
  MOMENT_ROUNDTRIP_FORMAT,
  parseZone,
  type DatetimeType,
} from './datetime';

// NOTE: null and undefined stay distinct. React reads null as "controlled with
// no value" and undefined as "uncontrolled", so collapsing them breaks pickers.
export function dayjsToMoment(value: DatetimeType): Moment;
export function dayjsToMoment(value: null): null;
export function dayjsToMoment(value: undefined): undefined;
export function dayjsToMoment(value: DatetimeType | null): Moment | null;
export function dayjsToMoment(
  value: DatetimeType | undefined
): Moment | undefined;
export function dayjsToMoment(
  value: DatetimeType | null | undefined
): Moment | null | undefined;
export function dayjsToMoment(
  value: DatetimeType | null | undefined
): Moment | null | undefined {
  if (value === null) return null;
  if (value === undefined) return undefined;
  // NOTE: the ISO round-trip preserves the display offset. `toDate()` and
  // `toISOString()` normalize to UTC and corrupt parseZone-style shift values.
  return moment.parseZone(value.format(MOMENT_ROUNDTRIP_FORMAT));
}

export function momentToDayjs(value: Moment): DatetimeType;
export function momentToDayjs(value: null): null;
export function momentToDayjs(value: undefined): undefined;
export function momentToDayjs(value: Moment | null): DatetimeType | null;
export function momentToDayjs(
  value: Moment | undefined
): DatetimeType | undefined;
export function momentToDayjs(
  value: Moment | null | undefined
): DatetimeType | null | undefined;
export function momentToDayjs(
  value: Moment | null | undefined
): DatetimeType | null | undefined {
  if (value === null) return null;
  if (value === undefined) return undefined;
  // NOTE: a local-mode moment recomputes its offset under DST-crossing
  // arithmetic, so it converts from the instant. A frozen one round-trips.
  if (value.isLocal()) {
    return datetime(value.valueOf());
  }
  return parseZone(value.format(MOMENT_ROUNDTRIP_FORMAT));
}

export function setMomentLocale(
  name: string,
  values: Record<string, unknown>
): void {
  moment.updateLocale(name, values);
}

export function toPickerValue(date?: string | null): Moment | null {
  return date ? dayjsToMoment(datetime(date)) : null;
}

export function toPickerTime(time: string): Moment {
  return dayjsToMoment(datetime(time, 'HH:mm'));
}

export function hydratePickerValue(value?: string | Moment) {
  return typeof value === 'string' ? dayjsToMoment(parseZone(value)) : value;
}

export type { Moment };
